import { DropdownContent } from '@anm/components/Dropdown';
import { TabsContentWrapper } from '@anm/components/HorizontalTabs';
import { PanelWrapper, TabsPanelWrapper } from '@anm/components/HorizontalTabs/Wrapper';
import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter, flexColumn, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

type MyStreamsHorizontalTabsProps = {
  isScrolled?: boolean;
  paddingBottom?: number;
};

const wrapperOnMobile = media.phone`
  padding-top: 0;
  margin-top: -35px;
  &&& ${TabsPanelWrapper} {
      padding: 0;
    }
`;

const panelScrollToTopStyles = css`
  top: 141px;
  transform: translateY(0);
`;

const wrapperOnTablet = media.tablet<{ scrollDirection: boolean }>`
  ${PanelWrapper} {
    padding: 17px 20px 25px;
    transform: translateY(-400%);
    ${({ scrollDirection }) => !scrollDirection && panelScrollToTopStyles};
  }
  ${TabsContentWrapper} {
    padding: 0 20px;
  }
`;

const myStreamsHorizontalTabsScrolledStyles = css`
  ${PanelWrapper} {
    box-shadow: rgb(1 83 130 / 10%) 0 2px 10px;
  }
`;

export const Wrapper = styled.div<MyStreamsHorizontalTabsProps>`
  ${flexColumn};
  height: 100%;
  ${PanelWrapper} {
    position: sticky;
    top: 0;
    padding: 27px 48px 24px 48px;
    background-color: #fff;
    z-index: 134;
    flex-direction: column;
    ${TabsPanelWrapper} {
      padding-bottom: 34px;
      padding-top: 2px;
    }
  }
  ${TabsContentWrapper} {
    flex: 1;
    padding: 0 48px ${({ paddingBottom }) => paddingBottom || 100}px;
    align-items: flex-start;
  }

  @media screen and (max-width: 1300px) {
    margin: 0;
  }
  ${wrapperOnMobile};
  ${wrapperOnTablet};
  ${({ isScrolled }) => isScrolled && myStreamsHorizontalTabsScrolledStyles};
`;

export const LoaderContainer = styled.div`
  ${flexCenter};
  min-height: 120px;
`;

export const EmptyListWrapper = styled.div<{ isArrow?: boolean }>`
  ${flexColumn};
  margin: auto;
  color: #292a2b;
  margin-top: 200px;
  position: relative;
  text-align: center;
  & > div {
    margin: auto;
    display: inline-block;
    position: relative;
    margin-bottom: 33px;
    & > img {
      width: 30px;
      height: 30px;
      margin-right: 18px;
    }
    ${({ isArrow }) =>
      isArrow &&
      css`
        &:before {
          content: '';
          top: -45px;
          width: 102px;
          height: 71px;
          right: -134px;
          position: absolute;
          background: url(${getFromCdn('images/dashboard/curveArrow.svg')}) no-repeat center / contain;
        }
      `}
  }
  h1 {
    display: inline;
    font-size: 30px;
    line-height: 42px;
  }
  ${DropdownContent} {
    left: 50%;
    width: 100%;
    & > div {
      width: 100%;
    }
    &:after,
    &:before {
      content: none;
    }
  }
`;

const mobileSection = media.phone`
  padding-top: 35px;
`;

export const SectionWrapper = styled.div`
  ${mobileSection};
`;
